import { useContext } from "react"
import { SideNavigation } from "@mezo-org/mezo-clay"
import { useRouterState } from "@tanstack/react-router"

import { resetDepositState, useDappDispatch } from "#/redux-state"
import { NAVIGATION_ITEMS } from "#/shared/constants"
import { FlowContext } from "#/shared/context"
import { useSinglePageRouterChange } from "#/shared/hooks"

import SidebarNavigationItem from "./SidebarNavigationItem"

export default function SidebarNavigationItemList() {
  const { flow } = useContext(FlowContext)

  const { changeRoute } = useSinglePageRouterChange()
  const dispatch = useDappDispatch()

  const {
    location: { pathname },
  } = useRouterState()

  return (
    <SideNavigation
      activeItemId={pathname}
      onChange={({ event, item }) => {
        // We need onChange event not to reload the page
        changeRoute(event, item.itemId)
        // We need to reset deposit state when entering any page
        dispatch(resetDepositState({ flow }))
      }}
      items={NAVIGATION_ITEMS.map(
        ({ navigationTitle, route, Icon, posthogDataAttribute }) => ({
          itemId: route,
          title: (
            <SidebarNavigationItem
              navigationTitle={navigationTitle}
              route={route}
              Icon={Icon}
              posthogDataAttribute={posthogDataAttribute}
            />
          ),
        }),
      )}
    />
  )
}
